export default {
      id: "icon-play-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }